import { graphql } from 'src/graphql';

export const InitializeUser = graphql(`
  mutation InitializeUser($input: InitializeUserInput!) {
    initializeUser(input: $input) {
      _id
    }
  }
`);
